import {observable, action, toJS} from 'mobx'
// import $ from 'jquery';
// import Cookies from 'js-cookie';
import ApiSettings from "../model/ApiSettings"
import CampaignSettings from "../model/CampaignSettings"
import ProfileSettingsEditState from "../model/form_state/ProfileSettingsEditState"
import Category from '../model/wa/Category'
import valueSourceOptionsGroupStorage from "../class/value_source/ValueSourceOptionsGroupStorage"
import valueSourceOptionsGroupsFactory from "../class/value_source/ValueSourceOptionsGroupsFactory";
import ValueSourceField from "../class/value_source/ValueSourceField";
import {FIXED_COMMA_SEPARATED} from "../constant/ValueSourceType"

export default class SettingsContext {
    /** @type {ApiSettings} */
    @observable settings

    @observable actions
    @observable delivery_methods
    @observable payment_methods
    @observable shop_payment_methods
    @observable api_url
    /** @type {CampaignSettings[]} */
    @observable campaigns = {}
    /** @type {Array<Category>} */
    @observable categories
    @observable sets
    @observable product_types
    @observable conditions
    @observable stocks
    @observable pvz_to_delete = []
    @observable regions_to_delete = []
    @observable conditions_to_delete = []
    @observable shipping_methods
    @observable is_create_region = false
    /** @type {ProfileSettingsEditState} */
    @observable form_state = new ProfileSettingsEditState()

    constructor(context) {
        const {
            currency_codes,
            product_fields,
            product_id_fields,
            features,
            price_fields,
            external_values_source_groups
        } = context
        this.api_url = context.api_url
        this.settings = context.settings
        this.actions = context.actions
        this.delivery_methods = context.delivery_methods
        this.payment_methods = context.payment_methods
        this.shop_payment_methods = context.shop_payment_methods
        this.categories = context.categories.map(c => new Category(c))
        this.sets = context.sets
        this.product_types = context.product_types
        this.conditions = context.conditions
        this.stocks = context.stocks
        this.shipping_methods = context.shipping_methods
        for (const [id, campaign] of Object.entries(context.campaigns)) {
            this.campaigns[id] = new CampaignSettings(campaign)
        }

        const product_source_fields = product_fields.map(f => new ValueSourceField(f))
        const product_id_source_fields = product_id_fields.map(f => new ValueSourceField(f))
        const feature_source_fields = features.map(feature => new ValueSourceField({
            field: feature.code,
            label: feature.name,
        }))
        const price_source_fields = price_fields.map(f => new ValueSourceField(f))

        valueSourceOptionsGroupStorage.init(
            product_source_fields,
            product_id_source_fields,
            feature_source_fields,
            price_source_fields,
            external_values_source_groups.map(g => new ExternalValuesSourceGroupMeta(g)),
            currency_codes,
            []
        )
    }

    @action
    async saveSettings() {
        console.log('save')
        return false
    }

    @action
    getCampaignsJson() {
        return JSON.stringify(this.campaigns)
    }

    lazyGetValueSourceOptions(field, _search, value_source) {
        return new Promise(resolve => {
            const options = []

            let search = ''
            if (_search) {
                search = _search.toLowerCase()
            }

            const options_groups = valueSourceOptionsGroupsFactory.getForDataset(field)

            for (const group of options_groups) {
                const is_empty_group = group.isEmpty() || group.isDefault()

                if (!search && is_empty_group) {
                    options.push({
                        is_empty: true,
                        label: group.group_label,
                        value: group.group_source_type,
                    })
                }

                if (!is_empty_group) {
                    const group_options = group.options
                        .filter(o => !search || o.label.toLowerCase().includes(search))
                        .map(o => ({
                            is_empty: false,
                            label: o.label,
                            value: `${group.group_source_type}/${o.value}`,
                        }))

                    if (group_options.length > 0) {
                        options.push({
                            is_empty: false,
                            label: group.group_label,
                            options: group_options,
                        })
                    }
                }
            }

            if (value_source.source_type === FIXED_COMMA_SEPARATED) {
                if (value_source.source_value.split(',').length > 1) {
                    options.push({
                        label: value_source.source_value,
                        value: value_source.source_value
                    })
                }
            }
            resolve(options)
        })
    }

}